import React, { useContext } from 'react';
import classnames from 'classnames';
import { NeuroMessage, AppContext } from '@ignitesales/neuro-application/src/neuro-guide';

const ProductCartButton = ({ onCartClick, currentCartCount }) => {

  const { productCart: stateProductCart } = useContext(AppContext);
  const productsInCart = Array.isArray(stateProductCart) ? new Set(stateProductCart) : stateProductCart;
  const activeClass = productsInCart.size > 1 ? 'active' : '';
  const classes = classnames('cart', 'action', activeClass);
  const cartCount = productsInCart.size;

  return <button className={ classes } onClick={ onCartClick } currentCartCount={ currentCartCount(cartCount) }>
    <span className="fa fa-shopping-cart"/>
    <NeuroMessage id="cart" tagName='h5' />
    <span className="cart-count">{ productsInCart.size }</span>
  </button>;
};

export default ProductCartButton;